export const handleCapsVariant = (isDisplayOnly, isBelowSmWidth) => {
  switch (true) {
    case !isDisplayOnly:
      return "h6";
    case isBelowSmWidth:
      return "subtitle2";
    // desktop size
    default:
      return "body1";
  }
};

export const handleCapsMarginBottom = (isDisplayOnly, isBelowSmWidth) => {
  switch (true) {
    case !isDisplayOnly:
      return "1rem";
    case isBelowSmWidth:
      return "0.2rem";
    // desktop size
    default:
      return "0.5rem";
  }
};

export const handleScoreWidth = (isDisplayOnly, isBelowSmWidth) => {
  switch (true) {
    case !isDisplayOnly:
      return "4.5rem";
    case isBelowSmWidth:
      return "2.35rem";
    // desktop size
    default:
      return "3.5rem";
  }
};

export const handleScorePadding = (isDisplayOnly, isBelowSmWidth) => {
  switch (true) {
    case !isDisplayOnly:
      return "0.4rem 0";
    case isBelowSmWidth:
      return "0";
    // desktop size
    default:
      return "0.2rem 0";
  }
};

export const handleScorePaddingBottom = (isDisplayOnly, isBelowSmWidth) => {
  switch (true) {
    case !isDisplayOnly:
      return "0.6rem";
    case isBelowSmWidth:
      return "0";
    // desktop size
    default:
      return "0.2rem";
  }
};

export const handleScoreVariant = (isDisplayOnly, isBelowSmWidth) => {
  switch (true) {
    case !isDisplayOnly:
      return "h5";
    case isBelowSmWidth:
      return "subtitle2";
    // desktop size
    default:
      return "h6";
  }
};

export const handleFavMaxChars = (isDisplayOnly, isBelowSmWidth) => {
  switch (true) {
    case !isDisplayOnly:
      return 21;
    case isBelowSmWidth:
      return 6;
    default:
      return 10;
  }
};

export const handleLogoMaxWidth = (isDisplayOnly, isBelowSmWidth) => {
  switch (true) {
    case !isDisplayOnly:
      return "4rem";
    case isBelowSmWidth && isDisplayOnly:
      return "1.75rem";
    default:
      return "2.5rem";
  }
};
